export default function (context, value) {
    context.dispatch('settings/change_data',{
        name: 'osv',
        field: 'filter',
        value
    },{root:true})
}